import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-d2e6ded6',
  styleUrl: './md-d2e6ded6.css',
  templateUrl: './md-d2e6ded6.html',
})
export class MdD2e6ded6 {
  readonly config = ENTITY_CONFIGS['d2e6ded6'];
}
